import React from "react";
import { Routes, Route } from "react-router-dom";
import { Container } from "@mui/material";
import { StageList } from "./StageList";
import { StageForm } from "./StageForm";
import { StageDetails } from "./StageDetails";

export const StagesPage: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Routes>
        <Route path="/" element={<StageList />} />
        <Route path="/new" element={<StageForm />} />
        <Route path="/:id" element={<StageDetails />} />
        <Route path="/:id/edit" element={<StageForm />} />
      </Routes>
    </Container>
  );
};
